import { Methods } from "@newview/infrastructure";
import {NewviewWebsiteBaseApi} from "./NewviewWebsiteBaseApi";


export class WebsiteProductServiceCoreFunctionsApi extends NewviewWebsiteBaseApi {

  public get ControllerName(): any {
    return 'website-product-service-core-functions'
  }



}